import { Box, Button, TextField, Typography } from "@mui/material"
import { UserAvatar } from "./UserAvatar"
import AddCommentIcon from '@mui/icons-material/AddComment';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MyListApi } from "../utils/restApi";
import { addNotification } from "../slices/notificationSlice";

const MAX_COMMENT_LENGTH = 256;
const MAX_NEW_LINES = 4;

export const NewComment = ({ entityType, entityId }) => {

    const dispatch = useDispatch();
    const user = useSelector(state => state.login.user);
    const [newComment, setNewComment] = useState('');

    const postComment = () => {
        MyListApi.createComment(newComment, entityType, entityId)
            .then(data => {
                // setComments([data, ...comments]);
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
        setNewComment('');
    }

    const handleComment = e => {
        const s = e.target.value;
        const newLineCount = s.split("\n").length;
        // if (s.length <= MAX_COMMENT_LENGTH && newLineCount <= MAX_NEW_LINES) {
            setNewComment(e.target.value);
        // }
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '12px', minWidth: 0 }}>
            <Box>
                <UserAvatar user={user} size='medium' />
            </Box>
            <Box sx={{ width: '100%', minWidth: 0 }}>
                <TextField multiline minRows={3} value={newComment} onChange={handleComment} placeholder="Add a comment" inputProps={{ 'aria-label': 'Add a comment' }} sx={{ minWidth: 0, width: '100%' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0 15px 0' }}>
                    <Typography variant="caption">{`${newComment.length}/${MAX_COMMENT_LENGTH}`}</Typography>
                    <Button variant="contained" size="small" endIcon={<AddCommentIcon />} onClick={postComment} disabled={!newComment.trim()}>Post</Button>
                </Box>
            </Box>
        </Box>
    )
}